<template>
  <div style="padding: 0;"
       v-if="initAt">
    <form  ref="setleForm" method="post" target="setleIframe" :action="action">
      <input type="hidden" name="mid"          v-model="mid">
      <input type="hidden" name="signKey"      v-model="signKey">
      <input type="hidden" name="gopaymethods" v-model="gopaymethods">
      <input type="hidden" name="goodsname"    v-model="goodsname">
      <input type="hidden" name="price"        v-model="price">
      <input type="hidden" name="buyername"    v-model="buyername">
      <input type="hidden" name="buyertel"     v-model="buyertel">
      <input type="hidden" name="buyeremail"   v-model="buyeremail">
      <input type="hidden" name="acceptmethod" v-model="acceptmethod">
      <input type="hidden" name="merchantData" v-model="merchantData">
    </form>
    <iframe id="setleIframe"
            name="setleIframe"
            style="width:820px; height:600px;"></iframe>
  </div>
</template>

<script>
export default {
  name: 'inicisSetlePopup',
  props: ['param', 'index'],
  computed: {
    action: function(){
      return this.domain + '/setle/api/inicis/inicisSetleRequest';
    }
  },
  data: function () {
    return {
      initAt: false,
      mid: '',
      signKey: '',
      domain:'',
      gopaymethods:'',
      goodsname: '',
      price: '',
      buyername: '',
      buyertel: '',
      buyeremail: '',
      acceptmethod: '',
      merchantData: '',
      finishFunc: null,
      closeFunc: null,
    }
  },
  methods: {
    init: function () {
      //아이오감 실시간 결제 관련 계정
      /*let mid     = 'i5gambaby1';
      let signKey = 'KzF4RHRic3BndEN3Ym0yM0tPb2RpZz09';*/

      //가치브라더 실시간 결제 관련 계정
      let mid     = 'withbro001';
      let signKey = 'KzgrNGNyMUk2cThhR2g5SytlUmo1UT09';

      let setleReturnUrl = '/setle/inicis/transactionInicisSetleReturn.act';

      const param = this.param;

      this.gopaymethods = param.gopaymethods;
      this.goodsname    = param.goodsname;
      this.price        = param.price;
      this.buyername    = param.buyername;
      this.buyertel     = param.buyertel;
      this.buyeremail   = param.buyeremail;

      if( this.gopaymethods == 'DirectBank' ){
        this.acceptmethod = ':no_receipt';
      }else if( this.gopaymethods == 'BILLAUTH' ){
        this.acceptmethod = ':BILLAUTH(card)';
        mid     = 'i5gambaby2';
        signKey = 'RmdEdllBQ0hVaDE1cnY2NnR0dFdaZz09';
        setleReturnUrl = '/setle/inicis/transactionCreateInicisBillkey.act';
      }

      if(window.location.hostname.indexOf('localhost') > -1) {
        this.domain = 'http://localhost:9180';
        setleReturnUrl = 'http://localhost:8080' + setleReturnUrl;
      } else if (window.location.hostname.indexOf('devi5gam.gulumma.net') > -1){
        this.domain = 'https://devi5gam.gulumma.net';
        setleReturnUrl = 'https://devi5gam.gulumma.net' + setleReturnUrl;
      } else if (window.location.hostname.indexOf('i5gam.gulumma.net') > -1){
        this.domain = 'https://i5gam.gulumma.net';
        setleReturnUrl = 'https://i5gam.gulumma.net' + setleReturnUrl;
      }

      this.mid          = mid;
      this.signKey      = signKey;
      param.merchantData['setleReturnUrl'] = setleReturnUrl;
      this.merchantData = JSON.stringify(param.merchantData);
      this.closeFunc    = param.closeFunc;
      this.finishFunc   = param.finishFunc;

      this.initAt = true;

      this.$nextTick(function(){
        this.setleDmnd();
      })
    },
    setleDmnd: function(){
      if(window.iniPayReqPopupEventListner){
        window.removeEventListener('message', window.iniPayReqPopupEventListner, false);
      }
      window.addEventListener('message', this.postMessageReceiver, false);
      window.iniPayReqPopupEventListner = this.postMessageReceiver;

      this.$refs.setleForm.submit();
    },
    postMessageReceiver : function(e){
      if(e.data.se == 'finish'){
        this.finishFunc(e.data.params, this.index);
      }else if(e.data.se == 'close'){
        this.closeFunc(this.index);
      }
    },
  },
  mounted: function () {
    this.init();
  }
}
</script>

<style scoped>

</style>
